import * as React from "react";
const SvgFiRrMeetingAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-meeting-alt_svg__a)">
      <path
        fill="#062147"
        d="M.5 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m8.5 14V23a1 1 0 0 1-2 0v-2.5a.5.5 0 0 0-.5-.5l-3.552-.001A3.003 3.003 0 0 1 0 17v-4c0-1.654 1.346-3 3-3s3 1.346 3 3v5h.5C7.878 18 9 19.122 9 20.5M4 18v-5c0-.551-.449-1-1-1s-1 .449-1 1v4c0 .551.449 1 1 1zm17-9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m3 4v4a3.003 3.003 0 0 1-2.948 2.999L17.5 20a.5.5 0 0 0-.5.5V23a1 1 0 0 1-2 0v-2.5c0-1.378 1.122-2.5 2.5-2.5h.5v-5c0-1.654 1.346-3 3-3s3 1.346 3 3m-2 0c0-.551-.449-1-1-1s-1 .449-1 1v5h1c.551 0 1-.449 1-1zm-6 1a1 1 0 0 0-1-1H9a1 1 0 0 0 0 2h6a1 1 0 0 0 1-1M7 5.048V2.952A2.955 2.955 0 0 1 9.952 0h4.096A2.955 2.955 0 0 1 17 2.952v2.096a2.957 2.957 0 0 1-2.672 2.939l-1.39 1.151a1.46 1.46 0 0 1-.977.365c-.363 0-.729-.128-1.021-.388L9.561 7.974A2.956 2.956 0 0 1 7 5.048m2 0c0 .525.427.952.952.952.233 0 .458.081.638.229l1.363 1.128 1.362-1.128a1 1 0 0 1 .638-.23h.096a.953.953 0 0 0 .952-.952V2.951a.953.953 0 0 0-.952-.952H9.953a.953.953 0 0 0-.952.952v2.096zM4 22H1a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2m19 0h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-meeting-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMeetingAlt;
